import Vue from 'vue'
import OrdersApi from './Api'

function fetchOrder(id) {
  return new OrdersApi().find(id).then(({ data }) => {
    return data
  })
}

/**
 * Function will check fresh order information for some statuses
 * and resolve/reject promise if status does not pass the check.
 * It performs 3 http api requests in 3 seconds interval.
 *
 * @param {Number} id Order ID
 * @param {Array} acceptStatuses List of statuses to check
 * @return {Promise<any>}
 */
export default function orderChecker(id, acceptStatuses = []) {
  return new Promise((resolve, reject) => {
    async function fetchAndCheck(iteration = 1) {
      const order = await fetchOrder(id)
      if (acceptStatuses.indexOf(order.status) !== -1) {
        resolve(order)
        return
      }

      if (iteration >= 3) {
        reject({
          message: Vue.$t('orders.messages.payment_failed'),
        })
      } else {
        setTimeout(() => fetchAndCheck(iteration + 1), 3000)
      }
    }

    fetchAndCheck()
  })
}
